module.exports = __webpack_public_path__ + "76769cabc09694d977815e32a70d82b6.svg";